// extracted by css-extract-rspack-plugin
export default {"root":"root-uDp4M9","bordered":"bordered-GncLow"};